import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSlidesWide"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H15.5C16.8807 4 18 5.11929 18 6.5V8H19.5C20.8807 8 22 9.11929 22 10.5V17.5C22 18.8807 20.8807 20 19.5 20H8.5C7.11929 20 6 18.8807 6 17.5V16H4.5C3.11929 16 2 14.8807 2 13.5V6.5ZM6 10.5V15H4.5C3.67157 15 3 14.3284 3 13.5V6.5C3 5.67157 3.67157 5 4.5 5H15.5C16.3284 5 17 5.67157 17 6.5V8H8.5C7.11929 8 6 9.11929 6 10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesWide;
